import React from "react";
import "./index.css";

const Navbar = (props) => {
    const { expanded, children } = props;

    let togglerClassMenu = `navbar-burger burger`;
    let menuClassName = `navbar-menu`;
    if (expanded) {
        togglerClassMenu = `${togglerClassMenu} is-active`;
        menuClassName = `${menuClassName} is-active`;
    }

    return (
        <nav className="navbar is-light has-shadows" aria-label="main navigation">
            <div className="container">
                <div className="navbar-brand">
                    <a href="/" className="navbar-item">
                        <b>
                            <span className="has-text-link">Формопласт АД</span>
                        </b>
                    </a>
                    <a
                        role="button"
                        className={togglerClassMenu}
                        aria-label="menu"
                        aria-expanded="false"
                        onClick={props.toggleExpanded}
                    >
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
                </div>
                <div className={menuClassName}>
                    <div className="navbar-end">{children}</div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/presentational/Navbar/index.js